import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import GoogleAnalytics from 'react-ga';

import Train from '../../services/train.js';
import User from '../../services/User.js';
import Element from '../../services/Element.js';
import Notification from '../../services/Notification.js';

class PasswordRecoveryForm extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      onClose: props.onClose,
      onFormChange: props.onFormChange
    }
  }

  successfulRequest(result) {
    User.startSession(result.token);
    let user = {user: User.getId(), name: User.getName()};
    this.props.history.push(Element.url('user', user));
    Notification.show(`Your password has been changed, ${User.getName()}`, 'success');
  }

  failedRequest(error) {
    Notification.show(`Invalid token`, 'error');
  }

  setNewPassword(evt) {

    let queryParams = new URLSearchParams(this.props.location.search);

    let token = queryParams.get('token');

    GoogleAnalytics.event({
      category: 'User',
      action: 'recoverPassword'
    });

    evt.preventDefault();
    evt.stopPropagation();

    let newPassword = this.refs.newPassword.value;

    Train.setNewPassword({newPassword, token})
    .then(this.successfulRequest.bind(this))
    .catch(this.failedRequest.bind(this));
  }

  validate() {
    this.setState({});
  }

  differentPasswords() {

    if (!this.refs.newPassword  || !this.refs.passwordConfirmation)
      return false;

    return this.refs.passwordConfirmation.value.length > 0 && this.refs.newPassword.value !== this.refs.passwordConfirmation.value
  }

  isInvalid() {

    return (
      (!this.refs.newPassword || !this.refs.passwordConfirmation) ||
      (!this.refs.newPassword.validity.valid) ||
      (!this.refs.passwordConfirmation.validity.valid) ||
      this.differentPasswords()
    );
  }

  render() {

    return (

      <form onSubmit={this.setNewPassword.bind(this)} className="userForm" noValidate>
        <fieldset>
          <h2 className="fs-title">Password Reset</h2>
          <input type="password" ref="newPassword" onChange={this.validate.bind(this)} minLength="8" maxLength="30" required placeholder="Password" />
          { this.refs.newPassword && this.refs.newPassword.validity.tooShort && <div>Your password should contain at least 8 characters</div> }
          { this.refs.newPassword && this.refs.newPassword.validity.tooLong && <div>Your password should contain no more than 20 characters</div> }

          <input type="password" ref="passwordConfirmation" onChange={this.validate.bind(this)} minLength="8" maxLength="30" required placeholder="Confirm password" />
          { this.refs.passwordConfirmation && this.refs.passwordConfirmation.validity.tooShort && <div>Your password should contain at least 8 characters</div> }
          { this.refs.passwordConfirmation && this.refs.passwordConfirmation.validity.tooLong && <div>Your password should contain no more than 20 characters</div> }

          { this.differentPasswords() && <div>Your confirmation must match your password</div> }
          <input disabled={this.isInvalid()} type="submit" className="submit action-button clickable" value="Change" />
        </fieldset>

      </form>

    );
  }

}

export default withRouter(PasswordRecoveryForm);



// WEBPACK FOOTER //
// ./src/js/components/credentials/PasswordRecoveryForm.jsx